import { getFacultyFaceURL } from 'utils'
import IntellectualPropertyModel from 'models/IntellectualPropertyModel'

export default class FacultyModel {
  id
  lincusAuthorId
  name
  title
  department
  email
  netid
  keywords
  publications
  collaborators
  intellectualPropertiesRaw

  constructor (obj) {
    if (obj.id === undefined || obj.name === undefined) {
      throw new Error('Insufficient information to create new FacultyModel')
    }

    this.id = obj.id
    this.lincusAuthorId = obj.lincus_author_id
    this.name = obj.name
    this.title = obj.title
    this.department = obj.department
    this.email = obj.email
    this.netid = obj.netid
    // dependent on last keyword searched author was a part of
    this.score = obj.score
    this.keywords = obj.keywords
    this.publications = obj.publications
    this.collaborators = obj.collaborators
    this.intellectualPropertiesRaw = obj.intellectualProperties
  }

  get intellectualProperties () {
    const ips = this.intellectualPropertiesRaw
      ? this.intellectualPropertiesRaw
      : []

    return ips
      .map(ip => ({
        ...ip,
        ...{ projecttype: { id: 1, name: 'Intellectual Property', slug: 'ip' } }
      }))
      .map(IntellectualPropertyModel.fromJS)
  }

  get facultyFaceUrl () {
    return this.netid ? getFacultyFaceURL(this.netid) : undefined
  }

  get easternName () {
    const name = this.name.split(', ')
    return `${name[1]} ${name[0]}`
  }

  get nameForGraph () {
    const name = this.name.split(', ')
    return `${name[1][0]}. ${name[0]}`
  }

  get content () {
    return `Publications and research from ${this.easternName}.`
  }

  static fromJS (obj) {
    return new FacultyModel(obj)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/FacultyModel.js